// extracted by mini-css-extract-plugin
export default {"calendar-wrapper":"style_calendar-wrapper__l-Yfc"};